export const renderImgSrc = (imgSrc, name) => {
    if (imgSrc) {
        let mimeType = 'image/png'; // default

        if (imgSrc.startsWith('/9j/')) mimeType = 'image/jpeg';
        else if (imgSrc.startsWith('iVBOR')) mimeType = 'image/png';
        else if (imgSrc.startsWith('R0lG')) mimeType = 'image/gif';
        else if (imgSrc.startsWith('UklG')) mimeType = 'image/webp';
        else if (imgSrc.startsWith('Qk')) mimeType = 'image/bmp';
        // const src = `data:${mimeType};base64,${imgSrc}`;
        // console.log("Final src length:", src.length);
        // console.log("Final src :", `data:${mimeType};base64,${imgSrc}`);

        return `data:${mimeType};base64,${imgSrc}`
    }
    return `https://ui-avatars.com/api/?name=${name}&background=e8eaff&color=2c25c4`
}